import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ScrollArea from 'react-scrollbar';

import CheckIcon from 'material-ui/svg-icons/navigation/check';
import ClearIcon from 'material-ui/svg-icons/navigation/close';

import { Grid, GridCell, GridFooter, GridHeader, GridRow } from '../../components/basic/grid';
import GridBody from '../../components/basic/grid/GridBody';
import Button from '../../components/basic/Button';
import PlainTextField from '../../components/basic/PlainTextField';

import { EOpportunityType } from '../../constants/Enums';

import * as opportunitiesActions from '../../actions/entities/OpportunitiesActions';
import { selectOpportunitiesFiltered } from '../../selectors/OpportunitiesSelector';

const renderType = type => {
  const e = EOpportunityType[type];
  if (e) {
    return <span>{e.label}</span>;
  }
  return <em>Unknown type '{type}'</em>;
};

const renderCompany = c => {
  if (!c) {
    return null;
  }
  return (
    <div>
      <small className="font-weight-light">
        {c.name} <span style={{ fontFamily: 'monospace' }}>({c.slug})</span>
      </small>
    </div>
  );
};

const renderDisplayed = p => {
  /**
   * NOT YET Displayed (orange)
   * -- will be displayed from
   * -- opt. will be displayed until
   *
   * Displayed (green)
   * -- displayed from
   * -- opt. will be displayed until
   *
   * NOT Displayed ANYMORE (grey)
   * -- was displayed from - until
   */
  const from = p.displayedFrom || p.createdAt;
  const to = p.displayedTo;
  const now = Date.now();

  if (from && now < from) {
    // not yet
    return (
      <div>
        <span className="text-warning">
          Will be displayed from {moment(from).calendar()} {to && `until ${moment(to).calendar()}`}
        </span>
      </div>
    );
  } else if (to && to < now) {
    // not anymore
    return (
      <div>
        <span className="text-muted">Not displayed anymore (until {moment(to).calendar()})</span>
      </div>
    );
  }
  // displayed
  return (
    <div>
      <span className="text-success">
        Displayed {from && `from ${moment(from).calendar()}`} {to && `to ${moment(to).calendar()}`}
      </span>
    </div>
  );
};

const renderPublished = p => {
  const published = !!p.publishedAt;
  const iconStyle = { width: 16, height: 16, color: 'inherit', marginRight: '4px', verticalAlign: 'middle' };
  return (
    <div>
      {published ? (
        <div className="text-success">
          <CheckIcon style={iconStyle} />
          <span style={{ verticalAlign: 'middle' }}>Published</span>
        </div>
      ) : (
        <div className="text-warning">
          <ClearIcon style={iconStyle} />
          <span style={{ verticalAlign: 'middle' }}>Not yet published</span>
        </div>
      )}
      {published && <div className="Text-small">{renderDisplayed(p)}</div>}
    </div>
  );
};

class OpportunitiesContainer extends React.Component {
  componentDidMount() {
    const { fetchOpportunities } = this.props;
    fetchOpportunities();
  }

  render() {
    const { opportunities, filter, setOpportunitiesFilter } = this.props;

    return (
      <div className="flex flex1">
        <Grid>
          <GridHeader>
            <GridRow className="row">
              <GridCell className="col-sm-4">
                <span>Opportunity</span>
              </GridCell>
              <GridCell className="col-sm-4">
                <span>Type</span>
              </GridCell>
              <GridCell className="col-sm-4">
                <span>Displayed</span>
              </GridCell>
            </GridRow>
            <GridRow className="row" style={{ padding: 0 }}>
              <GridCell className="col-sm-12" style={{ padding: 0 }}>
                <PlainTextField
                  placeholder="Filter..."
                  value={filter}
                  onChange={e => setOpportunitiesFilter(e.target.value)}
                  label="Filter"
                />
              </GridCell>
            </GridRow>
          </GridHeader>
          <ScrollArea smoothScrolling>
            <GridBody>
              {R.map(
                o => (
                  <Link key={o.id} to={`/settings/opportunities/${o.id}`}>
                    <GridRow className="row">
                      <GridCell className="col-sm-4">
                        <span>{o.title}</span>
                        {o.opportunity.company && renderCompany(o.opportunity.company)}
                      </GridCell>
                      <GridCell className="col-sm-4">{renderType(o.opportunity.type)}</GridCell>
                      <GridCell className="col-sm-4">{renderPublished(o)}</GridCell>
                      {o.tags &&
                        o.tags.length > 0 && (
                          <GridCell className="col-sm-12">
                            {R.map(
                              t => (
                                <span key={t} className="badge badge-info" style={{ marginRight: '4px' }}>
                                  {t}
                                </span>
                              ),
                              o.tags
                            )}
                          </GridCell>
                        )}
                    </GridRow>
                  </Link>
                ),
                opportunities
              )}
            </GridBody>
          </ScrollArea>
          <GridFooter>
            <GridRow className="Grid-pagination row">
              <GridCell className="col-sm-12">
                <div className="clearfix">
                  <div className="float-left" style={{ padding: '0.5em' }}>
                    <Button
                      label="Create"
                      raised
                      primary
                      style={{ fontSize: '16px' }}
                      containerElement={<Link to="/settings/opportunities/new" />}
                    />
                  </div>
                </div>
              </GridCell>
            </GridRow>
          </GridFooter>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  opportunities: selectOpportunitiesFiltered(state),
  filter: state.entities.opportunities.filter
});

export default connect(mapStateToProps, opportunitiesActions)(OpportunitiesContainer);



// WEBPACK FOOTER //
// ./src/containers/private/OpportunitiesContainer.js